export default __webpack_public_path__ + "static/media/Thesis.7c96b63a.png";